import { useNavigate } from "react-router-dom";
import { Badge, Box, HStack, IconButton, Menu, MenuButton, MenuItem, MenuList, Table, Tbody, Td, Text, Th, Thead, Tr } from "@chakra-ui/react";
import { HiDotsVertical } from "react-icons/hi";
import { MarketBar, NextChip, StageDots, relativeTime } from "../placing/PlacingSummaryParts";

/** The user's deals, one row each, in the placing style. Clicking a row opens the deal's Placements tab. */
const DealsList = ({ rows, productNames, emptyText }) => {
  const navigate = useNavigate();
  const dealLink = (deal, tab) => `/product/${deal.productCode}/deal/${deal._id}/deal${tab ? `?tab=${tab}` : ""}`;

  if (!rows.length) return <Text p={6} fontSize="sm" color="gray.500">{emptyText}</Text>;
  return (
    <Box overflowX="auto">
      <Table size="sm">
        <Thead>
          <Tr><Th>Deal</Th><Th>Placements</Th><Th>Stage</Th><Th>Market</Th><Th>Next for you</Th><Th>Updated</Th><Th /></Tr>
        </Thead>
        <Tbody>
          {rows.map((r) => {
            const { deal, lead } = r;
            return (
              <Tr key={deal._id} bg={r.needsYou ? "orange.50" : undefined} cursor="pointer"
                _hover={{ bg: r.needsYou ? "orange.100" : "blackAlpha.50" }}
                onClick={() => navigate(dealLink(deal, r.placements.length ? "placements" : undefined))}>
                <Td>
                  <HStack spacing={2}>
                    <Text fontWeight="semibold">{deal.name || "Untitled deal"}</Text>
                    {r.isNew && <Badge colorScheme="red" variant="solid" borderRadius="full" fontSize="0.6em">NEW</Badge>}
                  </HStack>
                  <Text fontSize="xs" color="gray.500">{productNames[deal.productCode] || deal.productCode || "—"}</Text>
                </Td>
                <Td>
                  {r.placements.length ? (
                    <>
                      <Text fontSize="sm">{r.placements.length}</Text>
                      {lead && r.placements.length > 1 && <Text fontSize="xs" color="gray.500" noOfLines={1}>showing {lead.placement.name}</Text>}
                    </>
                  ) : (
                    <Text fontSize="xs" color="gray.400">none yet</Text>
                  )}
                </Td>
                <Td>{lead ? <StageDots summary={lead} /> : <Text color="gray.400">—</Text>}</Td>
                <Td>{lead ? <MarketBar market={lead.market} /> : <Text color="gray.400">—</Text>}</Td>
                <Td>
                  {lead ? (
                    <HStack spacing={1}>
                      <NextChip next={lead.next} />
                      {r.needsYou > 1 && <Text fontSize="xs" color="orange.700">+{r.needsYou - 1} more</Text>}
                    </HStack>
                  ) : (
                    <Text color="gray.400">—</Text>
                  )}
                </Td>
                <Td color="gray.600" fontSize="sm">{relativeTime(r.updated)}</Td>
                <Td textAlign="right" onClick={(e) => e.stopPropagation()}>
                  <Menu placement="bottom-end">
                    <MenuButton as={IconButton} size="xs" variant="ghost" aria-label="Deal actions" icon={<HiDotsVertical />} />
                    <MenuList fontSize="sm">
                      <MenuItem onClick={() => navigate(dealLink(deal))}>Open deal</MenuItem>
                      <MenuItem onClick={() => navigate(dealLink(deal, "placements"))}>Placements</MenuItem>
                      <MenuItem onClick={() => navigate(`/product/${deal.productCode}/deal/${deal._id}/signal`)}>Create standard signal</MenuItem>
                    </MenuList>
                  </Menu>
                </Td>
              </Tr>
            );
          })}
        </Tbody>
      </Table>
    </Box>
  );
};

export default DealsList;
